import SlotEventCardSimple from "./SlotEventCardSimple";

export default ({ event, onClickEvent }) => {
  return (
    <div
      className={`calendar-a-row${event.timeStart === -1 ? " calendar-a-row-fullday" : ""}`}
    >
      <SlotEventCardSimple
        key={event.id}
        event={event}
        onClickEvent={onClickEvent}
        bigText={true}
      />
    </div>
  );
};
